import { ExpandIcon } from "@/assets/icons";
import classNames from "classnames";
import {
  MediaControlBar,
  MediaDurationDisplay,
  MediaPlayButton,
  MediaTimeDisplay,
  MediaTimeRange,
} from "media-chrome/react";
import { memo } from "react";
import PauseIcon from "../assets/pause.svg";
import PlayIcon from "../assets/play.svg";
import styles from "../index.module.css";

interface ControlBarProps {
  showControls: boolean;
  handleExpand: () => void;
}

export const ControlBar = memo(
  ({ showControls, handleExpand }: ControlBarProps) => {
    if (!showControls) return null;

    return (
      <div className="w-full flex items-center justify-end px-4 gap-3 bg-gradient-to-t from-[rgba(32,32,32,0.4)] to-transparent">
        <MediaControlBar
          className={classNames(styles.controlBar, "controller-bar")}
        >
          <MediaPlayButton className="bg-transparent mr-2">
            <PlayIcon className="w-[24px] h-[24px]" slot="play" />
            <PauseIcon className="w-[24px] h-[24px]" slot="pause" />
          </MediaPlayButton>
          <div className="flex items-center gap-2 flex-1">
            <MediaTimeDisplay className="bg-transparent"></MediaTimeDisplay>
            <MediaTimeRange className={styles.timeRange}>
              <span slot="preview"></span>
            </MediaTimeRange>
            <MediaDurationDisplay />
          </div>
        </MediaControlBar>

        <ExpandIcon
          onClick={handleExpand}
          className="cursor-pointer text-white"
          aria-label="Expand video player"
          role="button"
        />
      </div>
    );
  }
);

ControlBar.displayName = "ControlBar";
